import { Mesh, MeshBasicMaterial, Object3D, PolyhedronGeometry } from 'three';

import type { Comment } from '@/types';

import { Pyramid3d } from './Pyramid3d';

/**
 * 此处主要为漏标，只有漏标有对应的 3D 交互
 */
const COMMENT_RED = '#F54C46';
const COMMENT_YELLOW = '#FFD400';
const COMMENT_GREEN = '#00D18B';

export class CommentFactory {
  static createFromComment(comment: Comment, options?: { canvasSize?: number[] }) {
    if (!comment.extra_info?.position) return null;
    const name = comment.uuid,
      status = comment.status,
      position = comment.extra_info.position;

    let color = COMMENT_RED;
    if (status === 'pending') {
      color = COMMENT_YELLOW;
    } else if (status === 'resolved') {
      color = COMMENT_GREEN;
    }
    const { canvasSize } = options || {};
    return Pyramid3d.createFromComment(name, position, { color, canvasSize });
  }

  static updateObjectByComment(target: Object3D, comment: Comment) {
    const status = comment.status;

    let color = COMMENT_RED;
    if (status === 'pending') {
      color = COMMENT_YELLOW;
    } else if (status === 'resolved') {
      color = COMMENT_GREEN;
    }

    target.userData.color !== color &&
      Pyramid3d.changeColor(target as Mesh<PolyhedronGeometry, MeshBasicMaterial>, color);
  }
}
